import type {
  InventorySystemProfileDTO,
  ListFilterFieldDef,
  TenantGroupDTO,
} from '../../../types'
import {
  VENUE_SEARCH_FILTER_FIELD,
  VENUE_TYPE_FILTER_FIELD,
} from '../../venueListFilterFields'

export function buildInventorySystemProfileToVenuesFilterFields(
  profiles: readonly InventorySystemProfileDTO[],
  tenantGroups: readonly TenantGroupDTO[]
): ListFilterFieldDef[] {
  const profileOptions = profiles
    .map((profile) => ({
      value: profile.id,
      label: `${profile.code} (${profile.id})`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
  const tenantGroupOptions = tenantGroups
    .map((group) => ({ value: group.id, label: `${group.code} (${group.id})` }))
    .sort((a, b) => a.label.localeCompare(b.label))
  return [
    VENUE_SEARCH_FILTER_FIELD,
    {
      key: 'profile',
      label: 'ISP Profile',
      kind: 'select',
      searchMode: 'contains',
      options: profileOptions,
    },
    {
      key: 'tenantGroup',
      label: 'Tenant Group',
      kind: 'select',
      searchMode: 'contains',
      options: tenantGroupOptions,
    },
    VENUE_TYPE_FILTER_FIELD,
  ]
}
